import React from 'react';

import { link } from '@aline/routes';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlineButton, AlineDialog } from 'src/components/generic';
import { Apollo } from 'src/gql/generated';

export function WorkflowCancelDialog({
  open,
  setOpen,
  workflowId,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  workflowId: UUID;
}): JSX.Element {
  const navigate = useNavigate();
  const [deleteWorkflow, { loading: deletingWorkflow }] = Apollo.useDeleteWorkflowMutation();

  async function deleteWorkflowAndGoToHome() {
    const { data } = await deleteWorkflow({ variables: { workflowId } });
    if (data) navigate(link.Home());
  }

  function keepDraft() {
    navigate(link.DashboardIndex());
  }

  return (
    <AlineDialog open={open} title="Keep draft?" onClose={() => setOpen(false)}>
      <DialogContent>
        <DialogContentText>
          Do you want to keep this draft workflow, or permanently delete?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <AlineButton
          color="primary"
          loading={deletingWorkflow}
          type="submit"
          variant="outlined"
          onClick={deleteWorkflowAndGoToHome}
        >
          Delete
        </AlineButton>
        <AlineButton color="primary" variant="contained" onClick={keepDraft}>
          Keep Draft
        </AlineButton>
      </DialogActions>
    </AlineDialog>
  );
}
